export type SupportSettingToggle = {
  enabled: boolean;
};

/**
 * Runtime feature kill switch in svc-support settings.
 * enabled: true → on for everyone. enabled: false → only bypassRequestors; empty list → off for everyone.
 */
export type SupportFeatureSetting = SupportSettingToggle & {
  bypassRequestors: string[];
};

export type BypassableFeatureKey =
  | 'SALES_INTENT_ROUTING'
  | 'FLIGHT_INTENT_ROUTING'
  | 'SUPPORT_INTENT_CLARIFICATION';

export const BYPASSABLE_FEATURE_KEYS = [
  'SALES_INTENT_ROUTING',
  'FLIGHT_INTENT_ROUTING',
  'SUPPORT_INTENT_CLARIFICATION',
] as const satisfies readonly BypassableFeatureKey[];

export const DEFAULT_BYPASSABLE_FEATURE_SETTING: SupportFeatureSetting = {
  enabled: false,
  bypassRequestors: [],
};

export interface SettingsFormData {
  GENESYS: SupportSettingToggle;
  CHRISTMAS: SupportSettingToggle;
  SIERRA_EMAIL_AI: SupportSettingToggle;
  SALES_INTENT_ROUTING: SupportFeatureSetting;
  FLIGHT_INTENT_ROUTING: SupportFeatureSetting;
  SUPPORT_INTENT_CLARIFICATION: SupportFeatureSetting;
}

export const DEFAULT_SETTINGS: SettingsFormData = {
  GENESYS: {
    enabled: false,
  },
  CHRISTMAS: {
    enabled: false,
  },
  SIERRA_EMAIL_AI: {
    enabled: true,
  },
  // Keep in sync with svc-zendesk supportSettings fail-closed defaults.
  SALES_INTENT_ROUTING: DEFAULT_BYPASSABLE_FEATURE_SETTING,
  FLIGHT_INTENT_ROUTING: DEFAULT_BYPASSABLE_FEATURE_SETTING,
  SUPPORT_INTENT_CLARIFICATION: DEFAULT_BYPASSABLE_FEATURE_SETTING,
};
